import List from "./List";
import Edit from "./Edit";
import New from "./New";

export default { List, Edit, New };
